(async () => {

  if (!customElements.get('mixed-cart')) {

    const { Fancybox } = await import('@fancyapps/ui');

    class MixedCartPopup extends HTMLElement {

      constructor() {
        super();

        // Scope
        const self = this;

        // Scope elements
        self.MixedCartPopupWrapper = self.querySelector('[data-mixed-cart-wrapper]');
        self.buttonClose = self.querySelector('[data-mixed-cart-close]');

        // Get options from element data and combine with default options
        if (self?.dataset.options) {
          self.dataOptions = JSON.parse(self.dataset.options);
        }

        self.options = {
          ...self.defaultOptions,
          ...self.dataOptions
        };

        self.init();

        // Listen to extra events when in Shopify editor
        if (Shopify.designMode) {
          // Update the swiper when the section event is triggerd
          window.addEventListener('shopify:section:load', (event) => {
            if (event.detail.sectionId == "shopify-section-mixed-cart-popup") {
              Fancybox.close();
              self.init();
            }
          });
        }
      }

      /**
       * Init the mixed cart popup plugin
       * @returns void
       */
      init() {
        // Scope
        const self = this;

        // Render popup if given
        if (!self.mayRenderCountryPopup()) {
          return false;
        }

        // button close popup
        self.buttonClose.addEventListener('click', self.closeMixedCartPopup.bind(this));

      }

      /**
       * Check if the popup may be rendered and that there is a message to show
       * @returns boolean
       */
      mayRenderCountryPopup() {

        // Scope
        const self = this;

        // guard: check if there are messages given
        if (self.options.popupMessages.length == 0) {
          return false;
        }

        return true;
      }

      /**
       * Render the mixed cart popup
       * @returns void
       */
      renderMixedCartPopup(MixedCart) {

        // Scope
        const self = this;

        const mixedCartData = self.options.popupMessages;

        // populate the wrapper with the mixedCart data
        self.MixedCartPopupWrapper.querySelector('[data-mixed-cart-title]').innerHTML = mixedCartData.title;

        // added product is a gift card
        if (MixedCart == 'giftcard') {
           self.MixedCartPopupWrapper.querySelector('[data-mixed-cart-text]').innerHTML = mixedCartData.bodyGiftCard;

        // added product is a normal product
        } else if (MixedCart == 'product') {
           self.MixedCartPopupWrapper.querySelector('[data-mixed-cart-text]').innerHTML = mixedCartData.bodyProduct;
        }
        self.MixedCartPopupWrapper.querySelector('[data-mixed-cart-url]').action = mixedCartData.cartUrl;
        self.MixedCartPopupWrapper.querySelector('[data-mixed-cart-label]').innerHTML = mixedCartData.cartButton;
        self.MixedCartPopupWrapper.querySelector('[data-mixed-cart-close]').value = mixedCartData.continueButton;

        // Open fancybox and set callback for destroy event
        Fancybox.show(
          [
            {
              src: self.MixedCartPopupWrapper,
              type: "html",
            },
          ],
          {
            mainClass: 'fancybox--is-mixed-cart',
            on: {
              destroy: () => {
                self.closeMixedCartPopup();
              }
            }
          }
        );
      }

      /**
       * Close mixed cart popup
       * @returns void
       */
      closeMixedCartPopup() {

        // Scope
        const self = this;

        Fancybox.close();
      }
    }

    window.MixedCartPopup = MixedCartPopup;
    customElements.define('mixed-cart', MixedCartPopup);
  }
})();
